import { getRecoil } from 'recoil-nexus';

import { postMove, postResign, postRematch } from '@/api/gameplay.service';
import { gameIdState } from '@/framework/game';
import { applyMoveSnapshot, hydrateFromSnapshot } from '@/realtime/game-channel';
import { resetBoardRematch } from '@/framework/board';
import { closeModal } from '@/use/useModal';

export function submitGameMove(col: number) {
  const token = getRecoil(gameIdState);
  if (!token) {
    return Promise.reject(new Error('No active game'));
  }
  return postMove(token, { col }).then((snap) => {
    if (snap && typeof snap === 'object') {
      applyMoveSnapshot(snap as Record<string, unknown>);
    }
    return snap;
  });
}

export function resignGame() {
  const token = getRecoil(gameIdState);
  if (!token) {
    return Promise.reject(new Error('No active game'));
  }
  return postResign(token);
}

export function rematchGame() {
  const token = getRecoil(gameIdState);
  if (!token) {
    return Promise.reject(new Error('No active game'));
  }
  return postRematch(token).then((snap) => {
    if (!snap || typeof snap !== 'object') {
      return snap;
    }
    const payload = snap as Record<string, unknown>;
    if (payload.restarted) {
      resetBoardRematch();
      closeModal();
      hydrateFromSnapshot(payload);
    } else if (Array.isArray(payload.players)) {
      hydrateFromSnapshot(payload);
    }
    return snap;
  });
}
